<template>
  <main class="flex-1 relative overflow-y-auto focus:outline-none" tabindex="0">
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8 ">
      <div class="md:flex md:items-center md:justify-between">
        <div class="flex min-w-0">
          <svg-vue class="content-title-icon" icon="font-awesome.credit-card-solid"></svg-vue>
          <h1 class="content-title">
            {{ $t('Payment gateways API configuration') }}
          </h1>
        </div>
        <div class="mt-4 flex md:mt-0 md:ml-4">
          <router-link class="btn btn-app" to="/admin/settings">
            {{ $t('Back') }}
          </router-link>
        </div>
      </div>
    </div>
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8 ">
      <div class="content-card-body">
        <loading :status="loading.cod"></loading>
        <form @submit.prevent="saveCod">
          <div class="px-4 py-5 bg-white sm:p-6">
            <template v-if="!$store.state.settings.is_acepting_repair">
              <div class="bg-red-100 border-l-4 border-red-500 mb-3 text-red-700 p-4" role="alert">
                <p class="font-bold">{{ 'Attention' }}</p>
                <p>
                  {{ $t('Please turn on accepting payment order,') }}
                  <router-link class="text-sm text-blue-500 hover:text-blue-600" to="/admin/settings/general">
                    {{ $t('go to general setting tab') }}
                  </router-link>
                </p>
              </div>
            </template>
            <div for="default_payment_gateway" class="col-span-3 mb-3">
              <strong class="py-3 form-description-head">
                {{ $t('Default payment gateway') }}
              </strong>
              <div class="pt-1">
                <select class="form-input bg-white" id="default_payment_gateway" v-model="cod.default_payment_gateway">
                  <option :value="null" disabled>
                    {{ $t('Select an option') }}
                  </option>
                  <option :value="null">
                    {{ $t('Any') }}
                  </option>
                  <option v-if="cod.cod_state" value="cod">{{ $t('Cash on delivery') }}</option>
                  <option v-if="braintree.bt_state" value="braintree">{{ $t('Card Payment') }} <small>(braintree)</small></option>
                  <option v-if="stripe.stripe_state" value="stripe">{{ $t('Card Payment') }} <small>(stripe)</small></option>
                  <option v-if="square.square_state" value="square">{{ $t('Card Payment') }} <small>(square)</small></option>
                </select>
              </div>
            </div>
            <strong class="py-3 mt-4 form-description-head">
              {{ $t('Cash on delivery configuration') }}
            </strong>
            <div class="grid grid-cols-3 gap-6">
              <div class="col-span-3">
                <label class="form-label" for="cod_state">{{ $t('State') }}</label>
                <input-switch
                  :disabled-label="$t('The stripe will be off and will not be available')"
                  :enabled-label="$t('The stripe allows to process payment')"
                  id="cod_state"
                  v-model="cod.cod_state"
                ></input-switch>
                <div class="form-description-text">
                  {{ $t('This will control COD status (on/off),') }}
                  {{ $t('This gateways will not be available to process when state is off') }}
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="inline-flex">
              <button class="btn btn-app rounded-md shadow-sm" type="submit">
                {{ $t('Save') }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8 ">
      <div class="content-card-body">
        <loading :status="loading.braintree"></loading>
        <form @submit.prevent="saveBraintree">
          <div class="px-4 py-5 bg-white sm:p-6">
            <strong class="py-3 form-description-head">
              {{ $t('Braintree API configuration') }}
            </strong>
            <div class="grid grid-cols-3 gap-6">
              <div class="col-span-3">
                <label class="form-label" for="bt_state">{{ $t('State') }}</label>
                <input-switch
                  :disabled-label="$t('The braintree will be off and repair will be not available')"
                  :enabled-label="$t('The braintree allows to process payment')"
                  id="bt_state"
                  v-model="braintree.bt_state"
                ></input-switch>
                <div class="form-description-text">
                  {{ $t('This will control braintree status (on/off),') }}
                  {{ $t('repair booking will be not available when state is off') }}
                </div>
              </div>
              <div class="col-span-3">
                <label class="form-label" for="bt_environment">{{ $t('Environment') }}</label>
                <div class="pt-1">
                  <select class="form-input bg-white" id="bt_environment" required v-model="braintree.bt_environment">
                    <option :value="null" disabled>
                      {{ $t('Select an option') }}
                    </option>
                    <option value="sandbox">{{ $t('Sandbox') }}</option>
                    <option value="production">{{ $t('Production') }}</option>
                  </select>
                </div>
              </div>
              <div class="col-span-3">
                <label class="form-label" for="bt_merchant_id">{{ $t('Merchant id') }}</label>
                <div class="pt-1">
                  <input
                    :placeholder="$t('Merchant id')"
                    class="form-input"
                    id="bt_merchant_id"
                    required
                    type="password"
                    v-model="braintree.bt_merchant_id"
                  />
                </div>
              </div>
              <div class="col-span-3">
                <label class="form-label" for="bt_public_key">{{ $t('Public key') }}</label>
                <div class="pt-1">
                  <input
                    :placeholder="$t('Public key')"
                    class="form-input"
                    id="bt_public_key"
                    required
                    type="password"
                    v-model="braintree.bt_public_key"
                  />
                </div>
              </div>
              <div class="col-span-3">
                <label class="form-label" for="bt_private_key">{{ $t('Private key') }}</label>
                <div class="pt-1">
                  <input
                    :placeholder="$t('Private key')"
                    class="form-input"
                    id="bt_private_key"
                    required
                    type="password"
                    v-model="braintree.bt_private_key"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="inline-flex">
              <button class="btn btn-app rounded-md shadow-sm" type="submit">
                {{ $t('Save') }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8 ">
      <div class="content-card-body">
        <loading :status="loading.stripe"></loading>
        <form @submit.prevent="saveStripe">
          <div class="px-4 py-5 bg-white sm:p-6">
            <strong class="py-3 form-description-head">
              {{ $t('Stripe API configuration') }}
            </strong>
            <div class="grid grid-cols-3 gap-6">
              <div class="col-span-3">
                <label class="form-label" for="stripe_state">{{ $t('State') }}</label>
                <input-switch
                  :disabled-label="$t('The stripe will be off and will not be available')"
                  :enabled-label="$t('The stripe allows to process payment')"
                  id="stripe_state"
                  v-model="stripe.stripe_state"
                ></input-switch>
                <div class="form-description-text">
                  {{ $t('This will control stripe status (on/off),') }}
                  {{ $t('This gateways will not be available to process repair when state is off') }}
                </div>
              </div>
              <div class="col-span-3">
                <label class="form-label" for="stripe_pk">{{ $t('Stripe public key') }}</label>
                <div class="pt-1">
                  <input :placeholder="$t('Stripe public key')" class="form-input" id="stripe_pk" required type="text" v-model="stripe.stripe_pk" />
                </div>
              </div>
              <div class="col-span-3">
                <label class="form-label" for="stripe_sk">{{ $t('Stripe secret key') }}</label>
                <div class="pt-1">
                  <input
                    :placeholder="$t('Stripe secret key')"
                    class="form-input"
                    id="stripe_sk"
                    required
                    type="password"
                    v-model="stripe.stripe_sk"
                  />
                </div>
              </div>
              <div class="col-span-3">
                <label class="form-label" for="currency">
                  {{ $t('Currency') }}
                  <a href="https://stripe.com/docs/currencies" target="_blank" class="text-sm text-blue-500 hover:text-blue-600" rel="noopener"
                    >({{ $t('See supported currencies') }})</a
                  >
                </label>
                <div class="pt-1">
                  <input :placeholder="$t('Currency')" class="form-input" id="currency" required type="text" v-model="stripe.stripe_currency" />
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="inline-flex">
              <button class="btn btn-app rounded-md shadow-sm" type="submit">
                {{ $t('Save') }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8 ">
      <div class="content-card-body">
        <loading :status="loading.square"></loading>
        <form @submit.prevent="saveSquare">
          <div class="px-4 py-5 bg-white sm:p-6">
            <strong class="py-3 form-description-head">
              {{ $t('Square API configuration') }}
            </strong>
            <div class="pt-3 grid grid-cols-3 gap-6">
              <div class="col-span-3">
                <label class="form-label" for="square_state">{{ $t('State') }}</label>
                <input-switch
                  :disabled-label="$t('The square will be off and will not be available')"
                  :enabled-label="$t('The square allows to process payment')"
                  id="square_state"
                  v-model="square.square_state"
                ></input-switch>
                <div class="form-description-text">
                  {{ $t('This will control stripe status (on/off),') }}
                  {{ $t('This gateway will not be available to process repair when state is off') }}
                </div>
              </div>

              <div class="col-span-3">
                <label class="form-label" for="square_sandbox">{{ $t('Is sandbox?') }}</label>
                <input-switch
                  :disabled-label="$t('This will process as production mode')"
                  :enabled-label="$t('This will process as sandbox mode')"
                  id="square_sandbox"
                  v-model="square.square_sandbox"
                ></input-switch>
                <div class="form-description-text">
                  {{ $t('This will control square payment processing via sandbox or production mode') }}
                </div>
              </div>

              <div class="col-span-3">
                <label class="form-label" for="square_application_id">{{ $t('Square application id') }}</label>
                <div class="pt-1">
                  <input
                    :placeholder="$t('Square application id')"
                    class="form-input"
                    id="square_application_id"
                    required
                    type="text"
                    v-model="square.square_application_id"
                  />
                </div>
              </div>
              <div class="col-span-3">
                <label class="form-label" for="square_location_id">{{ $t('Square location id') }}</label>
                <div class="pt-1">
                  <input
                    :placeholder="$t('Square location id')"
                    class="form-input"
                    id="square_location_id"
                    required
                    type="text"
                    v-model="square.square_location_id"
                  />
                </div>
              </div>
              <div class="col-span-3">
                <label class="form-label" for="square_token">{{ $t('Square token') }}</label>
                <div class="pt-1">
                  <input
                    :placeholder="$t('Square token')"
                    class="form-input"
                    id="square_token"
                    required
                    type="password"
                    v-model="square.square_token"
                  />
                </div>
              </div>
              <div class="col-span-3">
                <label class="form-label" for="square_currency">
                  {{ $t('Currency') }}
                </label>
                <div class="pt-1">
                  <input
                    :placeholder="$t('Currency')"
                    class="form-input"
                    id="square_currency"
                    required
                    type="text"
                    v-model="square.square_currency"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="inline-flex">
              <button class="btn btn-app rounded-md shadow-sm" type="submit">
                {{ $t('Save') }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  name: 'gateways',
  data() {
    return {
      loading: {
        braintree: false,
        stripe: false,
        cod: false,
        square: false,
      },
      cod: {
        cod_state: false,
        default_payment_gateway: null,
      },
      stripe: {
        stripe_state: false,
        stripe_sk: null,
        stripe_pk: null,
        stripe_currency: null,
      },
      braintree: {
        bt_state: false,
        bt_environment: 'sandbox',
        bt_merchant_id: null,
        bt_public_key: null,
        bt_private_key: null,
      },
      square: {
        square_state: false,
        square_sandbox: true,
        square_application_id: null,
        square_location_id: null,
        square_token: null,
        square_currency: null,
      },
    };
  },
  mounted() {
    this.getBraintree();
    this.getStripe();
    this.getCod();
    this.getSquare();
  },
  methods: {
    getSquare() {
      this.loading.square = false;
      axios
        .get(route('settings.get.square'))
        .then((response) => {
          this.square = response.data;
          this.loading.square = false;
        })
        .catch(function() {
          this.$router.push('/admin/settings');
        });
    },
    getCod() {
      this.loading.cod = false;
      axios
        .get(route('settings.get.cod'))
        .then((response) => {
          this.cod = response.data;
          this.loading.cod = false;
        })
        .catch(function() {
          this.$router.push('/admin/settings');
        });
    },
    getBraintree() {
      this.loading.braintree = false;
      axios
        .get(route('settings.get.braintree'))
        .then((response) => {
          this.braintree = response.data;
          this.loading.braintree = false;
        })
        .catch(function() {
          this.$router.push('/admin/settings');
        });
    },
    getStripe() {
      this.loading.stripe = false;
      axios
        .get(route('settings.get.stripe'))
        .then((response) => {
          this.stripe = response.data;
          this.loading.stripe = false;
        })
        .catch(function() {
          this.$router.push('/admin/settings');
        });
    },
    saveBraintree() {
      this.loading.braintree = true;
      axios
        .post(route('settings.set.braintree'), this.braintree)
        .then((response) => {
          this.loading.braintree = false;
          this.$store.state.settings.braintree_state = this.braintree.bt_state;
          this.$notify({
            title: this.$i18n.t('Success').toString(),
            text: response.data.message.toString(),
            type: 'success',
          });
        })
        .catch(() => {
          this.loading.braintree = false;
        });
    },
    saveStripe() {
      this.loading.stripe = true;
      axios
        .post(route('settings.set.stripe'), this.stripe)
        .then((response) => {
          this.loading.stripe = false;
          this.$store.state.settings.stripe_state = this.stripe.stripe_state;
          this.$notify({
            title: this.$i18n.t('Success').toString(),
            text: response.data.message.toString(),
            type: 'success',
          });
        })
        .catch(() => {
          this.loading.stripe = false;
        });
    },
    saveCod() {
      this.loading.cod = true;
      axios
        .post(route('settings.set.cod'), this.cod)
        .then((response) => {
          this.loading.cod = false;
          this.$store.state.settings.cod_state = this.cod.cod_state;
          this.$store.state.settings.default_gateway = this.cod.default_payment_gateway;
          this.$notify({
            title: this.$i18n.t('Success').toString(),
            text: response.data.message.toString(),
            type: 'success',
          });
        })
        .catch(() => {
          this.loading.cod = false;
        });
    },
    saveSquare() {
      this.loading.square = true;
      axios
        .post(route('settings.set.square'), this.square)
        .then((response) => {
          this.loading.square = false;
          this.$notify({
            title: this.$i18n.t('Success').toString(),
            text: response.data.message.toString(),
            type: 'success',
          });
        })
        .catch(() => {
          this.loading.square = false;
        });
    },
  },
};
</script>
